import {
  LoadingAlert,
  Table,
  WalletFoundButNoAssetsFoundWarningAlert,
} from '@/components';
import { TableRowProps } from '@/components/molecules/Table/interfaces/Table';
import WalletTokenListItem from '@/components/organisms/WalletTokenListItem/WalletTokenListItem';
import { useWalletsContext } from '@/components/providers/postauth/UserWalletsProvider';
import { WalletTokenInterface } from '@/interfaces/WalletTokenInterface';
import { logError, logInfo } from '@/utils/logger';
import { WALLET } from '@/utils/strings';
import React, { FC } from 'react';
interface Props {
  onSelectAsset: (asset: WalletTokenInterface | undefined) => void;
  tokens?: WalletTokenInterface[];
}
const UserAssetsList: FC<Props> = ({
  onSelectAsset,
  tokens: initialTokens,
}) => {
  const {
    tokens: contextTokens,
    isLoading: loading,
    error,
  } = useWalletsContext();
  const tokens = initialTokens || contextTokens;
  if (loading) {
    logInfo('Loading user portfolio assets', 'UserAssetsList');
    <LoadingAlert
      title={WALLET.LOADING_TITLE}
      description={WALLET.LOADING_DESCRIPTION}
    />;
  }
  if (error) {
    logError('Error loading user portfolio assets', 'UserAssetsList', {
      error,
    });
  }
  const rows: TableRowProps[] = tokens.map((token) => ({
    cells: [
      {
        mainText: (
          <WalletTokenListItem
            token={token}
            showNetwork
            showNetworkPrefix
            showBalance
            showBalancePrefix
            showWalletAddress
            showWalletAddressPrefix
            showWalletAddressCopyButton={false}
          />
        ),
        align: 'left',
      },
    ],
  }));
  const handleRowClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    rowIndex: number,
  ) => {
    const selectedAsset = tokens[rowIndex];
    onSelectAsset(selectedAsset);
  };
  const renderNoAssetsMessage = () => (
    <WalletFoundButNoAssetsFoundWarningAlert />
  );
  return (
    <>
      {rows.length > 0 ? (
        <Table columnWidths={[100]} rows={rows} onClickRow={handleRowClick} />
      ) : (
        renderNoAssetsMessage()
      )}
    </>
  );
};
export default UserAssetsList;
